import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, Box, Typography } from '@mui/material';
import { UserApi } from '../../../apis'; // Adjust as needed

const validationSchema = Yup.object({
    newPassword: Yup.string()
        .required('New password is required')
        .min(8, 'New password should be at least 8 characters long'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
        .required('Confirm password is required'),
});

function ChangePassword({ close, userId }) {
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            newPassword: '',
            confirmPassword: '',
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true);
                await UserApi.changePassword({
                    newPassword: values.newPassword,
                    id: userId
                });
                close();
            } catch (error) {
                console.error('Error changing password:', error);
            } finally {
                setLoading(false);
            }
        },
    });

    return (
        <Box component="form" onSubmit={formik.handleSubmit} sx={{ '& .MuiTextField-root': { mb: 2 }, margin: 'auto' }}>
            <Typography variant="h7" component="div" gutterBottom>
                New Password
            </Typography>
            <TextField
                fullWidth
                id="newPassword"
                name="newPassword"
                label="New Password"
                type="password"
                value={formik.values.newPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
                helperText={formik.touched.newPassword && formik.errors.newPassword}
            />
            <Typography variant="h7" component="div" gutterBottom>
                Confirm Password
            </Typography>
            <TextField
                fullWidth
                id="confirmPassword"
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
            />

            <Button color="primary" variant="contained" fullWidth type="submit" disabled={loading}>
                {loading ? 'Updating...' : 'Change Password'}
            </Button>
        </Box>
    );
}

export default ChangePassword;
